/**
 * Takes a full user name and strips out the group which is defined
 * as the last token of the space delimited string
 *
 * @param name User name including the group
 * @returns User name without group
 */
export function removeUserGroup(name?: string): string {
  if (!name?.length) {
    return '';
  }
  const tokens = name.split(' ');
  return tokens.join(' ');
}
